export const COMPANY = {
  name: "Gregory Tile",
  fullName: "Gregory Tile & Home Remodeling",
  phone: "(256) 555-8453",
  phoneHref: "tel:+12565558453",
  email: "quotes@gregorytile.com",
  city: "Huntsville, Alabama",
  hours: "Monday – Saturday · 8:00 AM – 6:00 PM",
  rating: "5.0",
  years: "15+",
  projects: "250+",
};

export const IMAGES = {
  heroBath:
    "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=1800&q=80",
  bathWalkIn:
    "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?auto=format&fit=crop&w=1400&q=80",
  bathMarble:
    "https://images.pexels.com/photos/4258278/pexels-photo-4258278.jpeg?auto=compress&cs=tinysrgb&w=1400",
  bathVanity:
    "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=1400&q=80",
  bathWhite:
    "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1400&q=80",
  kitchenIsland:
    "https://images.unsplash.com/photo-1665507279638-5b48073c637b?auto=format&fit=crop&w=1400&q=80",
  kitchenGourmet:
    "https://images.pexels.com/photos/4030049/pexels-photo-4030049.jpeg?auto=compress&cs=tinysrgb&w=1400",
  kitchenWarm:
    "https://images.unsplash.com/photo-1556911220-bff31c812dba?auto=format&fit=crop&w=1400&q=80",
  kitchenBright:
    "https://images.unsplash.com/photo-1600585152220-90363fe7e115?auto=format&fit=crop&w=1400&q=80",
  floorHardwood:
    "https://images.pexels.com/photos/39383577/pexels-photo-39383577.jpeg?auto=compress&cs=tinysrgb&w=1400",
  floorOak:
    "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?auto=format&fit=crop&w=1400&q=80",
  craftsman:
    "https://images.pexels.com/photos/38076239/pexels-photo-38076239.jpeg?auto=compress&cs=tinysrgb&w=1400",
  interior:
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1400&q=80",
  homeHuntsville:
    "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80",
  homeSuburban:
    "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1800&q=80",
};

export const PROJECT_TYPES = [
  "Bathroom Remodeling",
  "Kitchen Remodeling",
  "Tile & Wood Flooring",
  "Other / Not Sure Yet",
];

export const SERVICES = [
  {
    slug: "bathroom-remodeling",
    name: "Bathroom Remodeling",
    short: "Bathrooms",
    tagline: "Spa-grade bathrooms, built by master tradesmen",
    description:
      "Walk-in showers, soaking tubs, custom vanities, and flawless tile — designed around your space and finished on schedule.",
    image: "/assets/work-e.jpg",
    heroImage: IMAGES.heroBath,
    features: ["Walk-in tile showers", "Vanities & fixtures", "Full gut remodels"],
    bullets: [
      "Master tradesmen on every job",
      "Waterproofing done right — guaranteed",
      "One dedicated crew, start to finish",
    ],
    includes: [
      { title: "Custom Tile Showers & Tub Surrounds", text: "Porcelain, ceramic, marble and stone — set with precision waterproofing systems." },
      { title: "Frameless Glass Enclosures", text: "Clean, modern enclosures measured and fitted to your new shower." },
      { title: "Vanities, Countertops & Fixtures", text: "Floating vanities, quartz tops, faucets and hardware — sourced and installed." },
      { title: "Heated & Slip-Resistant Tile Floors", text: "Warm underfoot, safe when wet, and beautiful for decades." },
      { title: "Lighting, Ventilation & Plumbing", text: "Licensed trade partners handle every rough-in and finish detail." },
      { title: "Full Gut Remodels & Layout Changes", text: "Moving walls, doors or drains? We design and rebuild the whole room." },
    ],
    faqs: [
      { q: "How much does a bathroom remodel cost in Huntsville?", a: "Most full bathroom remodels we complete in the Huntsville area range from $12,000 to $30,000 depending on size, tile selection and layout changes. Every project starts with a free in-home estimate so you get an exact number — no surprises." },
      { q: "How long does a bathroom remodel take?", a: "A typical hall bath takes about 2 weeks; a master bath with a custom tile shower runs 3–4 weeks. We give you a written schedule before we start and one crew stays on your job until it's done." },
      { q: "Do you handle the plumbing and electrical work?", a: "Yes. We coordinate licensed plumbing and electrical partners for all rough-in and fixture work, so you never have to hire or manage separate contractors." },
      { q: "Can I choose my own tile and materials?", a: "Absolutely. We guide you through selections at local showrooms, or we're happy to install quality materials you've already purchased." },
      { q: "Is your work warrantied?", a: "Every project includes a 2-year workmanship warranty, plus manufacturer warranties on tile, fixtures and waterproofing systems." },
    ],
    metaTitle: "Bathroom Remodeling Huntsville AL | Free Estimates | Gregory Tile",
    metaDesc:
      "Bathroom remodeling in Huntsville, Madison & Athens, AL. Custom tile showers, vanities and full bath renovations by Gregory Tile. Licensed & insured — get a free estimate.",
    h1: "Bathroom Remodeling in Huntsville, AL",
  },
  {
    slug: "kitchen-remodeling",
    name: "Kitchen Remodeling",
    short: "Kitchens",
    tagline: "Kitchens built for the way your family actually lives",
    description:
      "Cabinetry, countertops, backsplashes and floors — a kitchen remodel managed by one crew from demo day to the final walkthrough.",
    image: IMAGES.kitchenIsland,
    heroImage: IMAGES.kitchenWarm,
    features: ["Custom cabinetry", "Tile backsplashes", "Islands & layouts"],
    bullets: [
      "Backsplashes & floors by master tradesmen",
      "Transparent, line-item estimates",
      "We keep your home livable during the build",
    ],
    includes: [
      { title: "Custom Cabinetry & Refacing", text: "New cabinets or a factory-finish reface — we help you choose what fits the budget." },
      { title: "Countertops", text: "Quartz, granite and butcher block, templated and installed to the millimeter." },
      { title: "Tile Backsplashes & Accent Walls", text: "Hand-set backsplash tile — the detail that makes the whole kitchen." },
      { title: "Kitchen Flooring", text: "Tile, hardwood and LVP floors that stand up to real family traffic." },
      { title: "Lighting, Plumbing & Layout Updates", text: "Under-cabinet lighting, pot fillers, moved islands — coordinated end to end." },
      { title: "Islands, Pantries & Storage", text: "Built-in storage solutions designed around how you cook and gather." },
    ],
    faqs: [
      { q: "How much does a kitchen remodel cost?", a: "Kitchen remodels in the Huntsville area typically range from $20,000 to $60,000 depending on cabinetry, countertops and layout changes. Your free estimate includes a detailed line-item breakdown." },
      { q: "How long will my kitchen be out of service?", a: "Most kitchen remodels take 3–6 weeks. We help you set up a temporary kitchen space and sequence the work to minimize downtime." },
      { q: "Can we stay in our home during the remodel?", a: "Yes — almost all of our clients do. We contain dust with zip-wall barriers, protect floors and clean the work area daily." },
      { q: "Do you help with design and material selection?", a: "Yes. Every project includes a design consultation where we plan the layout and select cabinets, counters, backsplash tile and finishes together." },
      { q: "Is your work warrantied?", a: "Every kitchen remodel includes a 2-year workmanship warranty plus full manufacturer warranties on all installed products." },
    ],
    metaTitle: "Kitchen Remodeling Huntsville & Madison AL | Gregory Tile",
    metaDesc:
      "Kitchen remodeling in Huntsville, Madison & Athens, AL. Cabinets, countertops, tile backsplashes and flooring by Gregory Tile. Free in-home estimates.",
    h1: "Kitchen Remodeling in Huntsville, AL",
  },
  {
    slug: "tile-wood-flooring",
    name: "Tile & Wood Flooring",
    short: "Flooring",
    tagline: "Floors set level, straight, and built to outlast trends",
    description:
      "Porcelain tile, hardwood, and luxury vinyl plank — installed over properly prepped subfloors with craftsman-grade finishes.",
    image: IMAGES.floorHardwood,
    heroImage: IMAGES.floorOak,
    features: ["Porcelain & ceramic tile", "Hardwood & LVP", "Showers & backsplashes"],
    bullets: [
      "Subfloor repair & leveling included",
      "Dust-controlled demo and clean jobsites",
      "Free moisture & wear consultation",
    ],
    includes: [
      { title: "Porcelain & Ceramic Tile", text: "Wood-look plank, large format and patterned tile set perfectly flat." },
      { title: "Hardwood & Engineered Wood", text: "Site-finished and pre-finished hardwood installed to manufacturer spec." },
      { title: "Luxury Vinyl Plank (LVP)", text: "Waterproof, kid-proof and pet-proof floors with a real-wood look." },
      { title: "Shower Pans & Wet-Area Tile", text: "Properly sloped, waterproofed shower floors that never leak." },
      { title: "Backsplashes & Accent Tile", text: "Kitchen backsplashes, fireplace surrounds and feature walls." },
      { title: "Subfloor Repair & Leveling", text: "The step most contractors skip — we fix what's underneath first." },
    ],
    faqs: [
      { q: "How much does new flooring cost per square foot?", a: "Installed pricing typically runs $6–$12 per sq ft for LVP, $8–$15 for porcelain tile, and $10–$18 for hardwood, depending on material and subfloor condition. Your free estimate includes exact measurements." },
      { q: "How long does a flooring project take?", a: "Most main-floor installations (800–1,500 sq ft) take 3–5 days including demo, prep and installation." },
      { q: "Tile or hardwood — which is right for my home?", a: "It depends on traffic, pets, moisture and budget. We'll walk your home, talk through the trade-offs, and recommend what actually fits your household — not what's most expensive." },
      { q: "Do you move the furniture?", a: "Yes. We move and protect furniture as part of the job and put everything back when we're done." },
      { q: "Is your flooring work warrantied?", a: "All installations include a 2-year workmanship warranty plus manufacturer product warranties." },
    ],
    metaTitle: "Tile & Wood Flooring Huntsville, Athens & Madison AL | Gregory Tile",
    metaDesc:
      "Tile, hardwood and LVP flooring installation in Huntsville, Madison & Athens, AL. Subfloor prep, showers and backsplashes by Gregory Tile. Free estimates.",
    h1: "Tile & Wood Flooring in Huntsville, AL",
  },
];

export const AREAS = [
  {
    slug: "huntsville",
    name: "Huntsville",
    county: "Madison County",
    heroImage: IMAGES.homeHuntsville,
    intro:
      "From the historic homes of Twickenham and Five Points to new builds in Hampton Cove, Huntsville homeowners trust Gregory Tile for remodels that respect the home and the budget.",
    neighborhoods: ["Hampton Cove", "Jones Valley", "Blossomwood", "Five Points", "Twickenham", "Meridianville", "Harvest", "Owens Cross Roads", "New Market", "Madison"],
    faqs: [
      { q: "Do you serve all of Huntsville?", a: "Yes — every Huntsville neighborhood from Hampton Cove to Research Park, plus surrounding Madison County communities like Harvest, Meridianville and Owens Cross Roads." },
      { q: "Do you work on older Huntsville homes?", a: "Absolutely. We've remodeled bathrooms and kitchens in Twickenham and Five Points homes over a century old, and we know how to handle the surprises older homes hide." },
      { q: "How soon can you start a project in Huntsville?", a: "Estimates are typically scheduled within 2–3 business days, and most projects start within 2–4 weeks of approval depending on material lead times." },
      { q: "Are permits required for remodeling in Huntsville?", a: "Some projects require permits through the City of Huntsville. We handle all permitting as part of the job — you never deal with paperwork." },
    ],
    metaTitle: "Home Remodeling Huntsville AL | Bathroom, Kitchen & Tile | Gregory Tile",
    metaDesc:
      "Gregory Tile serves every Huntsville, AL neighborhood — Hampton Cove, Jones Valley, Blossomwood & more. Bathroom, kitchen and flooring remodels. Free estimates.",
  },
  {
    slug: "madison",
    name: "Madison",
    county: "Madison County",
    heroImage: IMAGES.homeSuburban,
    intro:
      "Madison is one of the fastest-growing cities in Alabama, and its homes deserve finishes to match. We remodel kitchens, baths and floors throughout Madison — from Clift Farm to County Line.",
    neighborhoods: ["Downtown Madison", "Clift Farm", "Bridgewater", "Edgewater", "County Line", "Browns Ferry", "Triana", "Monrovia", "Capshaw", "Huntsville"],
    faqs: [
      { q: "Do you serve Madison, AL?", a: "Yes — all of Madison including Clift Farm, Bridgewater, Edgewater, County Line and Triana, as well as nearby Monrovia and Capshaw." },
      { q: "What's the most popular remodel in Madison?", a: "Kitchen refreshes with new backsplash tile and main-floor flooring replacements are our most requested Madison projects, followed closely by master bath shower rebuilds." },
      { q: "How soon can you start a project in Madison?", a: "Estimates are typically scheduled within 2–3 business days, and most projects start within 2–4 weeks of approval." },
      { q: "Do you handle HOA or permit requirements?", a: "Yes. Where Madison requires permits or HOA approvals, we prepare and submit everything on your behalf." },
    ],
    metaTitle: "Kitchen & Bathroom Remodeling Madison AL | Gregory Tile",
    metaDesc:
      "Remodeling contractor serving Madison, AL — kitchens, bathrooms, tile and wood flooring. Licensed & insured, free in-home estimates from Gregory Tile.",
  },
  {
    slug: "athens",
    name: "Athens",
    county: "Limestone County",
    heroImage: IMAGES.interior,
    intro:
      "Across Limestone County, from downtown Athens to East Limestone and Tanner, homeowners call Gregory Tile for honest estimates and tile work that stays perfect for decades.",
    neighborhoods: ["Downtown Athens", "East Limestone", "West Limestone", "Tanner", "Elkmont", "Ardmore", "Belle Mina", "Mooresville", "Decatur", "Madison"],
    faqs: [
      { q: "Do you serve Athens and Limestone County?", a: "Yes — Athens, East and West Limestone, Tanner, Elkmont, Ardmore, Belle Mina and Mooresville, plus nearby Decatur." },
      { q: "Is there a travel charge for Athens projects?", a: "No. Athens and all of Limestone County are inside our core service area — estimates are free and pricing is identical to Huntsville." },
      { q: "What's the most popular remodel in Athens?", a: "Tile shower rebuilds and whole-home flooring replacements lead our Athens work, especially in newer East Limestone construction." },
      { q: "How soon can you start a project in Athens?", a: "Estimates are typically scheduled within 2–3 business days, and most projects start within 2–4 weeks of approval." },
    ],
    metaTitle: "Tile, Bathroom & Kitchen Remodeling Athens AL | Gregory Tile",
    metaDesc:
      "Remodeling contractor serving Athens & Limestone County, AL — tile showers, kitchens, hardwood and LVP flooring. Free estimates from Gregory Tile.",
  },
];

export const OTHER_AREAS = ["Decatur", "Harvest", "Owens Cross Roads", "Hampton Cove", "Meridianville", "Hazel Green", "New Market", "Toney"];

export const STATS = [
  { value: "15+", label: "Years of Craftsmanship" },
  { value: "250+", label: "Projects Completed" },
  { value: "5.0", label: "Google Rating" },
  { value: "3", label: "Counties Served" },
];

export const TESTIMONIALS = [
  {
    quote: "Gregory Tile turned our dated master bath into a spa. The walk-in shower tile work is flawless — not one uneven line. They showed up when they said they would, every single day.",
    name: "Jennifer M.",
    city: "Hampton Cove",
    project: "Master Bathroom Remodel",
  },
  {
    quote: "From demo to the final grout line, the crew was professional, tidy and fast. Our new kitchen backsplash is the first thing every guest comments on.",
    name: "David & Lisa R.",
    city: "Madison",
    project: "Kitchen Remodel",
  },
  {
    quote: "They replaced our whole main floor with wood-look tile and fixed a subfloor dip two other contractors wanted to ignore. Honest people, beautiful work.",
    name: "Marcus T.",
    city: "Athens",
    project: "Tile Flooring Installation",
  },
  {
    quote: "On time, on budget, zero surprises. The estimate was itemized down to the last fixture, and the finished kitchen is even better than the design.",
    name: "Sarah W.",
    city: "Harvest",
    project: "Kitchen & Flooring Remodel",
  },
];

export const PROJECTS = [
  { image: "/assets/work-e.jpg", title: "Master Bath Transformation", city: "", category: "Bathrooms", alt: "Finished master bathroom remodel with frameless glass shower and freestanding tub by Gregory Tile" },
  { image: "/assets/work-d.jpg", title: "Walk-In Shower with Bench Seat", city: "", category: "Bathrooms", alt: "Finished walk-in tile shower with bench seat and hex floor tile by Gregory Tile" },
  { image: "/assets/work-c.jpg", title: "Black Marble Statement Shower", city: "", category: "Bathrooms", alt: "Black marble-look tile shower with hexagon niches under construction by Gregory Tile" },
  { image: IMAGES.kitchenIsland, title: "Island & Backsplash Remodel", city: "Madison", category: "Kitchens", alt: "Kitchen island with tile backsplash remodel in Madison AL" },
  { image: IMAGES.kitchenGourmet, title: "Gourmet Kitchen Refresh", city: "Blossomwood", category: "Kitchens", alt: "Gourmet kitchen remodel with granite countertops in Blossomwood" },
  { image: IMAGES.floorHardwood, title: "Wide-Plank Hardwood Install", city: "Athens", category: "Flooring", alt: "Wide plank hardwood flooring installation in Athens AL" },
  { image: IMAGES.floorOak, title: "Main-Floor Oak Flooring", city: "Harvest", category: "Flooring", alt: "Oak hardwood flooring installation in Harvest AL" },
];

export const GENERAL_FAQS = [
  { q: "Are estimates really free?", a: "Yes — every estimate is free and comes with a written, line-item quote. We'll visit your home, measure, talk through materials and give you a real number, not a range that grows later." },
  { q: "Are you licensed and insured?", a: "Yes. Gregory Tile is fully licensed and carries general liability insurance and workers' compensation on every job. Certificates are available on request." },
  { q: "How long does a typical remodel take?", a: "Hall baths run about 2 weeks, master baths 3–4 weeks, kitchens 3–6 weeks, and most flooring projects 3–5 days. You get a written schedule before work begins." },
  { q: "Do you offer financing?", a: "We offer flexible payment schedules tied to project milestones, and we can connect you with local financing partners for larger remodels." },
  { q: "Which areas do you serve?", a: "Huntsville, Madison, Athens and the surrounding Madison, Limestone and Morgan County communities — including Harvest, Decatur, Hampton Cove, Meridianville and Owens Cross Roads." },
  { q: "Is your work guaranteed?", a: "Every project includes a 2-year workmanship warranty plus manufacturer warranties on all materials we install. If something isn't right, we come back and make it right." },
];
